
const pushLocation = (location, router) => {
  let path;
  if (typeof location === 'object') {
    const { href, basename, slug } = location;
    if (href) {
      path = href;
    } else {
      path = `${basename}/${slug}`;
    }
  } else if (typeof location === 'string') {
    path = location;
  }

  if (router && router.history) {
    const { history } = router;
    history.push(path);
  }
};

export default pushLocation;



// WEBPACK FOOTER //
// ./src/utils/pushLocation.js